import type { ICartFullResponse, ICartFullResponseItem } from '#shared/api';
import type { TCartFullEntityTrackerPayload } from '~/features/store';
import type { ITrackerCartOptions, TTrackerSuborders } from '~/features/clickstream-sdk';

export class CartFullTrackerMapper {
  public mapTrackerPayload(response: ICartFullResponse): TCartFullEntityTrackerPayload {
    return {
      address: response.deliveryInfo.address.fullAddress,
      store_id: response.deliveryInfo.store.storeCode,
      free_delivery_cost: response.deliveryPrices.freeDeliveryMinPrice,
      suborders: this.mapSuborders(response.id, response?.suborders?.[0]?.items ?? []),
      cartOptions: this.mapCartOptions(response),
    };
  }

  private mapCartOptions(response: ICartFullResponse): ITrackerCartOptions {
    const cart_sum = response.summary.totalBasePrice;
    const cart_discount = response.summary.discounts.reduce((acc, it) => acc + it.value, 0);

    return {
      promocode_name: '',
      bonusToggle_activated: 0,
      cart_bonus_writeoff: 0,
      cart_bonus_earn: 0,
      cart_bonus_balance: 0,
      delivery_cost: response.deliveryPrices.deliveryPrice,
      cart_discount,
      cart_sum,
    };
  }

  private mapSuborders(cartId: string, cartItems: ICartFullResponseItem[]): TTrackerSuborders {
    const suborder: TTrackerSuborders[number] = {
      id: cartId,
      products: cartItems.map((it) => ({
        product_id: it.productId,
        seller_id: it.shopInfo?.id,
        quantity: it.qnty,
        selected: it.selected,
        has18: it.isForAdults,
      })),
    };

    return [suborder];
  }
}
